import { render, staticRenderFns } from "./PersonOfInterest.vue?vue&type=template&id=271c2b23&scoped=true"
import script from "./PersonOfInterest.vue?vue&type=script&lang=js"
export * from "./PersonOfInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c2b23",
  null
  
)

export default component.exports